import * as breakpoints from "../breakpoints";
import * as colors from "../constants/colors";
import { StyleSheet } from "aphrodite";

export default StyleSheet.create({
	button: {
		border: "none",
		borderRadius: 20,
		backgroundColor: colors.lightTeal,
		color: colors.black2,
		fontWeight: "bold",
		lineHeight: 1.4,
		fontSize: 15,
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		paddingTop: 10,
		paddingBottom: 10,
		width: 154,
	},
	buttonContainer: {
		textAlign: "center",
		marginTop: 32,
	},
	errorMessage: {
		color: colors.errorRed,
		fontSize: 12,
		lineHeight: 1.67,
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		marginTop: 6,
	},
	form: {
		marginTop: 8,
	},
	formItem: {
		marginTop: 22,
		display: "flex",
		flexDirection: "column",
	},
	input: {
		width: 460,
		height: 40,
		fontSize: 15,
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		border: `1px solid ${colors.gray2}`,
		[breakpoints.tabletAndDown]: {
			width: "auto",
		},
	},
	inputError: {
		border: `1px solid ${colors.errorRed}`,
	},
	label: {
		lineHeight: 1.33,
		color: colors.black4,
		fontSize: 15,
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		marginBottom: 10,
	},
});



// WEBPACK FOOTER //
// ./src/styles/loginStyles.js